import React, { useState } from "react";

/**
 * Settings Page - Works for Admin, Staff, or Student
 * - Shows and edits user profile (name, email, phone, position/role)
 * - Handles password change
 * - If no userProfile prop is passed, uses a blank/default profile
 * - For real use, connect to API (currently uses onUpdateProfile callback if provided)
 */
export default function Settings({ userProfile = {}, onUpdateProfile }) {
  const [editMode, setEditMode] = useState(false);
  const [form, setForm] = useState({
    name: userProfile?.name || "",
    email: userProfile?.email || "",
    phone: userProfile?.phone || "",
    position: userProfile?.position || userProfile?.role || "",
    password: ""
  });
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleInputChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setMessage("");
    setError("");
  };

  const handleEditToggle = () => {
    setEditMode((mode) => !mode);
    setMessage("");
    setError("");
  };

  const handleProfileSave = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email) {
      setError("Name and Email are required.");
      return;
    }
    try {
      // Replace this with a real API call if desired
      if (onUpdateProfile) await onUpdateProfile(form);
      setMessage("Profile updated successfully.");
      setEditMode(false);
    } catch (err) {
      setError("Failed to update profile.");
    }
  };

  const handlePasswordChange = async (e) => {
    e.preventDefault();
    if (!form.password || form.password.length < 6) {
      setError("Password must be at least 6 characters.");
      return;
    }
    try {
      // Replace this with a real API call if desired
      setMessage("Password changed successfully.");
      setForm({ ...form, password: "" });
    } catch (err) {
      setError("Failed to change password.");
    }
  };

  return (
    <div className="module-wrapper settings-module">
      <h2>Settings</h2>
      <p>Manage your profile details and password.</p>
      <div className="settings-profile">
        {!editMode ? (
          <>
            <div className="profile-row"><b>Name:</b> {form.name}</div>
            <div className="profile-row"><b>Email:</b> {form.email}</div>
            <div className="profile-row"><b>Phone:</b> {form.phone || <span style={{ color: "#999" }}>—</span>}</div>
            <div className="profile-row"><b>Position:</b> {form.position || <span style={{ color: "#999" }}>—</span>}</div>
            <button className="primary-action" onClick={handleEditToggle} style={{marginTop: 10}}>Edit Profile</button>
          </>
        ) : (
          <form className="profile-form" onSubmit={handleProfileSave}>
            <div className="form-row">
              <label>Name:</label>
              <input name="name" value={form.name} onChange={handleInputChange} required />
            </div>
            <div className="form-row">
              <label>Email:</label>
              <input name="email" value={form.email} onChange={handleInputChange} required />
            </div>
            <div className="form-row">
              <label>Phone:</label>
              <input name="phone" value={form.phone} onChange={handleInputChange} />
            </div>
            <div className="form-row">
              <label>Position:</label>
              <input name="position" value={form.position} onChange={handleInputChange} />
            </div>
            <div style={{marginTop: 10}}>
              <button type="submit" className="primary-action">Save</button>
              <button type="button" onClick={handleEditToggle} style={{ marginLeft: 8 }}>Cancel</button>
            </div>
          </form>
        )}
      </div>
      <div className="settings-password">
        <h3>Change Password</h3>
        <form className="password-form" onSubmit={handlePasswordChange}>
          <div className="form-row">
            <label>New Password:</label>
            <input
              name="password"
              type="password"
              value={form.password}
              onChange={handleInputChange}
              placeholder="Enter new password"
              required
            />
          </div>
          <button type="submit" className="primary-action">Update Password</button>
        </form>
      </div>
      {(message || error) && (
        <div className={error ? "form-error" : "form-success"} style={{marginTop: 18}}>
          {error || message}
        </div>
      )}
    </div>
  );
}